/* eslint-disable no-restricted-imports */
import {
    LinearProgress as OgLinearProgress,
    LinearProgressProps as OgLinearProgressProps,
} from '@mui/material';
import { useMemo } from 'react';
import { sxAppend } from '../../sx';

const styleCurvedCorners = (withCurvedCorners: boolean) => ({
    borderRadius: withCurvedCorners ? 5 : 0,
});

export type LinearProgressProps = OgLinearProgressProps & {
    withCurvedCorners?: boolean;
};

export function LinearProgress({
    withCurvedCorners = false,
    sx,
    ...props
}: LinearProgressProps) {
    const curvedCornerStyle = useMemo(
        () => styleCurvedCorners(withCurvedCorners),
        [withCurvedCorners]
    );

    return <OgLinearProgress sx={sxAppend(curvedCornerStyle, sx)} {...props} />;
}
